import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from '../../common';
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    GET_SNAPSHOT_REPORT: (snapshotId) => ({ snapshotId }),
    API: {
      GET_SNAPSHOT_REPORT: apiResourceActionCreator('report')
    }
  }
})

export const apiAction = (authToken, snapshotId) => commonApiActions.authenticated.get(`${USER_RESOURCE_ENDPOINT(RESOURCES.SnapshotReport)}/${snapshotId}`, authToken, actions.user.api.getSnapshotReport)

export function* getSnapshotReport(action) {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken, action.payload.snapshotId));
  }
}

const configuration = {
  name: 'getSnapshotReport',
  action: actions,
  sagas: getSnapshotReport,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingSnapshotReport: true
    }),
    success: (state, action) => ({
      ...state,
      snapshotReport: action.payload.report,
      isFetchingSnapshotReport: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      isFetchingSnapshotReport: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getSnapshotReport.js